import { Helmet } from 'react-helmet-async';

const SITE = 'https://waitlistpoker.com';

type SEOProps = {
  title?: string;
  description?: string;
  path?: string;           // e.g. '/', '/how-it-works', '/privacy', '/terms'
  index?: boolean;         // default true; set false for auth/admin
};

export function SEO({ title, description, path = '/', index = true }: SEOProps) {
  const url = path.startsWith('http') ? path : `${SITE}${path}`;
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta name="robots" content={index ? 'index,follow' : 'noindex,nofollow'} />
      <meta property="og:url" content={url} />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content="website" />
    </Helmet>
  );
}
